import { getThermalServiceUrl } from "lib/utils/connection";
import { authedFetch } from "lib/utils/authedFetch";

export type ThermalThresholdResponse = {
    threshold_c: number;
};

async function parseError(res: Response): Promise<string> {
    let detail = res.statusText;
    try {
        const err = (await res.json()) as { error?: string };
        if (err.error) detail = err.error;
    } catch {
        /* ignore */
    }
    return detail;
}

function requireServiceUrl(url: string | null): string {
    if (!url) throw new Error("Fleet proxy host is unavailable");
    return url;
}

export async function getThermalThreshold(
    host: string,
    isSecure: boolean,
    arcId?: string | null
): Promise<ThermalThresholdResponse> {
    const url = requireServiceUrl(getThermalServiceUrl(host, "threshold", isSecure, arcId));
    const res = await authedFetch(url);
    if (!res.ok) throw new Error(await parseError(res));
    return (await res.json()) as ThermalThresholdResponse;
}

export async function putThermalThreshold(
    host: string,
    threshold_c: number,
    isSecure: boolean,
    arcId?: string | null
): Promise<ThermalThresholdResponse> {
    const url = requireServiceUrl(getThermalServiceUrl(host, "threshold", isSecure, arcId));
    const res = await authedFetch(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ threshold_c }),
    });
    if (!res.ok) throw new Error(await parseError(res));
    return (await res.json()) as ThermalThresholdResponse;
}
